__turbopack_context__.v({
  "active": "Footer-module-scss-module__giXM_a__active",
  "addressLine": "Footer-module-scss-module__giXM_a__addressLine",
  "bottomContainer": "Footer-module-scss-module__giXM_a__bottomContainer",
  "column": "Footer-module-scss-module__giXM_a__column",
  "columnTitle": "Footer-module-scss-module__giXM_a__columnTitle",
  "company": "Footer-module-scss-module__giXM_a__company",
  "container": "Footer-module-scss-module__giXM_a__container",
  "copyright": "Footer-module-scss-module__giXM_a__copyright",
  "footerBottom": "Footer-module-scss-module__giXM_a__footerBottom",
  "line": "Footer-module-scss-module__giXM_a__line",
  "link": "Footer-module-scss-module__giXM_a__link",
  "logo": "Footer-module-scss-module__giXM_a__logo",
  "pulseLink": "Footer-module-scss-module__giXM_a__pulseLink",
  "root": "Footer-module-scss-module__giXM_a__root",
  "sides": "Footer-module-scss-module__giXM_a__sides",
  "siteFooter": "Footer-module-scss-module__giXM_a__siteFooter",
  "socials": "Footer-module-scss-module__giXM_a__socials",
});
